/**
 * Normalize a raw unit string for case- and punctuation-insensitive matching
 * against the canonical units catalog.
 *
 * Rules: lowercase, then drop everything that is not a-z or 0-9.
 *
 * Examples:
 *   "Ea."        -> "ea"        (matches code "EA")
 *   "sq.yd."     -> "sqyd"      (matches variant "SQYD" if present)
 *   "linft"      -> "linft"
 *   "Lin Ft"     -> "linft"
 *   "Square Yds" -> "squareyds"
 *
 * Safe to import from server OR client code.
 */
export function normalizeUnitToken(
  input: string | null | undefined,
): string | null {
  if (input == null) {
    return null;
  }
  const cleaned = input.toLowerCase().replace(/[^a-z0-9]+/g, '');
  return cleaned.length > 0 ? cleaned : null;
}
